import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=347b2a21&lang=pug&"
import script from "./ContractView.vue?vue&type=script&lang=ts&"
export * from "./ContractView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports